<script lang="ts">
  import { contrastRatio, wcagGrade, type ContrastGrade } from '@/lib/wcag-contrast';

  let {
    foreground,
    background,
    label = '',
    largeText = false,
    note = '',
  }: {
    foreground: string | null | undefined;
    background: string | null | undefined;
    label?: string;
    largeText?: boolean;
    /** Optional caveat shown after the badge (e.g. when the bg is a gradient). */
    note?: string;
  } = $props();

  const ratio = $derived(contrastRatio(foreground, background));
  const grade = $derived<ContrastGrade | null>(
    ratio == null ? null : wcagGrade(ratio, { largeText })
  );

  const palette: Record<ContrastGrade, string> = {
    AAA: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
    AA: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    'AA Large': 'bg-amber-50 text-amber-800 ring-amber-200',
    Fail: 'bg-rose-50 text-rose-700 ring-rose-200',
  };
</script>

<span class="inline-flex flex-wrap items-center gap-1.5">
  {#if ratio == null}
    <span class="inline-flex items-center gap-1 rounded-full bg-stone-100 dark:bg-stone-700 px-2 py-0.5 text-[10px] font-medium text-stone-500 dark:text-stone-400 ring-1 ring-stone-200 dark:ring-stone-600">
      {label ? `${label} ` : ''}contrast: —
    </span>
  {:else}
    <span class={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ${palette[grade!]}`}>
      {#if label}<span class="font-normal opacity-80">{label}</span>{/if}
      {ratio.toFixed(2)}:1 · {grade}
    </span>
  {/if}
  {#if note}
    <span class="text-[10px] leading-3 text-stone-400 dark:text-stone-500">{note}</span>
  {/if}
</span>
